<template
  src="./index.html"
  lang="html"
/>
<style
  src="../../stylus/main.css"
  lang="css">
</style>
<script>

  import prvInput from "../../components/prv-input/prv-input.vue";
  import prvDropdown from "../../components/prv-dropdown/prv-dropdown.vue";

  export default {
    components: {
      'prv-input': prvInput,
      'prv-dropdown': prvDropdown
    },
    data(){
      return {
        user:            null,
        password:        null,
        confirmPassword: null,
        token:           null,
        confirmCode:     null,
        status: {
          noToken:       true,
          expired:       false,
          forbidden:     false,
          badPassword:   false,
          success:       false
        }
      }
    },
    computed: {
      samePassword() {
        return this.password === this.confirmPassword;
      }
    },
    beforeRouteEnter(to, from, next) {

      next(vm => {

         if (!vm.$route.query.token) {
           vm.$router.push({
              path: '/'
           });
         }
      });
    },
    created() {
      this.validateToken();
    },
    methods: {
      validateToken() {

        this.token = this.$route.query.token;
        this.status.noToken = false;

        fetch('/api/v1/signin', {
          method: 'HEAD',
          headers: {
            'accept': '*/*',
            'X-Check': this.token
          },
          cors: 'no-cors',
          cache: 'no-cache',
        })
        .then(response => {

          switch(response.status) {

            case 204:
             this.confirmCode = response.headers.get('X-Reset-Code');
            break;

            case 401:
              this.status.expired = true;
            break;

            case 403:
              this.status.forbidden = true;
            break;

          }
        })
        .catch(
          //TODO: MANAGE 500
        );
      },
      save() {

          if (!this.password || !this.confirmPassword || !this.samePassword) {
            return this;
          }

          fetch('/api/v1/signin', {
            method: 'PATCH',
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json',
              'X-Code': this.confirmCode,
            },
            cors: 'no-cors',
            cache: 'no-cache',
            body: JSON.stringify({d1: this.password})
          })
          .then(response => {

            switch(response.status) {

              case 204:
                this.status.success = true;
              break;

              case 401:
                this.status.expired = true;
              break;

              case 403:
                this.status.forbidden = true;
              break;

              case 422:
                this.status.badPassword = true;
              break;
            }
          })
          .catch(
            //TODO: MANAGE 500
          );
      },
      end() {

        this.$router.push({
          path: '/'
        });
      }
    }
  }
</script>
